var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"uk-tooltip":`title: ${_vm.textContent}; pos: ${_vm.position}; offset: ${_vm.offset}`}},[_c('i',{staticClass:"fas fa-info-circle fa-xs icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }